// Group orders are purchased on fixed days of the month, per category.
// Keep in sync with api/util/purchaseDate.js.
const PURCHASE_DAYS = { Restaurant: [1, 15] }
const DEFAULT_DAYS = [1]

export const purchaseDaysFor = (category) =>
  PURCHASE_DAYS[category] || DEFAULT_DAYS

// The next purchase day on or after today.
export const nextPurchaseDate = (category, now = new Date()) => {
  const days = purchaseDaysFor(category)
  const day = days.find((d) => d >= now.getDate())

  return day
    ? new Date(now.getFullYear(), now.getMonth(), day)
    : new Date(now.getFullYear(), now.getMonth() + 1, days[0])
}

export const formatPurchaseDate = (category) =>
  nextPurchaseDate(category).toLocaleDateString("en-PH", {
    month: "long",
    day: "numeric",
    year: "numeric",
  })

const ordinal = (d) => (d === 1 ? "1st" : d === 2 ? "2nd" : d === 3 ? "3rd" : `${d}th`)

// e.g. "1st & 15th of every month"
export const purchaseScheduleLabel = (category) =>
  `${purchaseDaysFor(category).map(ordinal).join(" & ")} of every month`
